import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../shared/config/app-config';
import { UserService, PatientService, User } from '../../shared';
import { ActivatedRoute } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service'
import { BsModalService } from 'ngx-bootstrap/modal';
import { ReturnStatement } from '@angular/compiler';


@Component({
  selector: 'app-securityquestion',
  templateUrl: './securityquestion.component.html',
  styleUrls: ['./securityquestion.component.css']
})
export class SecurityquestionComponent implements OnInit {
  fullyear: number = new Date().getFullYear();
  param: any;
  securityAnswertd: any;
  errorAttempt: any;
  csrModal: BsModalRef
  wrongAttemptValues: any;
  wrongMessageValues: any;
  secQuestionName: string;

  constructor(private router: Router, private userService: UserService,
    private patientservice: PatientService,
    private nav: Router,
    private modalService: BsModalService, private actRoute: ActivatedRoute) { }

  allowPassChange: boolean = false;
  helpDeskNo: any;
  patname: any = '';
  cpName: string;
  language: any;
  dateform: any;
  userName: any;
  patientId: any;
  public dateformat = environment.dateFormat;
  public bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });

  ngOnInit() {
    this.errorAttempt = 0;
    if (window.localStorage['randId'])
    this.getWrongCredentials(window.localStorage['randId']);
    if (window.localStorage['mail']) {
      this.userService.forgotUserInfo(window.localStorage['mail'])
        .subscribe(
          data1 => {
            if (data1) {
              this.patname = data1.firstName + ' ' + data1.lastName;
              if (data1.patFirstName) {
                this.cpName = data1.patFirstName + ' ' + data1.patLastName
              }
              this.userName = window.localStorage['mail']
              this.patientId = data1.patientId
              this.allowPassChange = data1.allowPasswordChange
              this.helpDeskNo = data1.helpDeskNo ? data1.helpDeskNo : '1-630-560-6805'
              this.language = data1.countryCode ? data1.countryCode : 'USA'
              window.localStorage['status'] = 'forgotlink'
              if (data1.dateFormat == 'DDMMYYYY') {
                this.dateformat = 'DD/MM/YYYY'
                this.dateform = 'dd/MM/yyyy'

                this.patientservice.us_Patient = false;

                if (navigator.userAgent.search("iPhone") != -1) {
                  this.nav.navigateByUrl('/appstore')
                }
              } else {
                this.dateformat = 'MM/DD/YYYY'
                this.dateform = environment.dateFormat
                if (navigator.userAgent.search("iPhone") != -1) {
                  this.nav.navigateByUrl('/appstore')
                  location.href = "https://apps.apple.com/us/app/rc-coach/id1475273242";
                }
              }
              this.bsConfig = { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat }
            }
          }
        );
    }

  }


  getWrongCredentials(email) {
    this.userService.getSecurityQuesWrongCredentials(email).subscribe(
      data => {
        this.wrongAttemptValues = data;
        this.securityAnswertd = ""
        if (this.wrongAttemptValues.status == 'Active') {
          this.getSecurityquestion(email);
        }
      },
      err => {
        this.wrongAttemptValues.status = 'Blocked';
      }
    );

  }


  getQuestionlList: any;
  getForgotSecurity: any;
  getValidateMsg: any;
  wrongUserSecQuestionId: string = "";
  getSecurityquestion(email) {
    this.getQuestionlList = "";
    const obj = {
      randId: email,
      wrongUserSecQuestionId: this.wrongUserSecQuestionId
    }

    this.userService.getSelectedQuestnListByUser(obj).subscribe(
      data => {
        this.getQuestionlList = data;
        this.secQuestionName = ""
        this.securityAnswertd = ""
        //console.log("getQuestionlList", data)
      }
    );
  }

  squestion() {

    this.userService.validateSelectedQuestnAnsByUser(window.localStorage['randId'], this.getQuestionlList[0].secQuestionId, this.securityAnswertd).subscribe(
      data => {
        this.getValidateMsg = data;
        if (this.getValidateMsg.status == 'Blocked') {
          this.wrongAttemptValues.status = 'Blocked';
          return;
        }
        if (this.getValidateMsg.message == "success") {
          if (window.localStorage['status'] == 'forgotlink')
            this.router.navigate(['/uservalidate']);
          else {
            window.localStorage['status'] = 'forgotlink'
            this.router.navigate(['/createcarepass']);
          }
        }
        else {
          //this.errorAttempt = this.errorAttempt  + 1;      
          //alert("error")
          this.wrongUserSecQuestionId = this.wrongUserSecQuestionId + ','
            + this.getQuestionlList[0].secQuestionId;

          this.getSecurityquestion(window.localStorage['randId']);
          this.securityAnswertd = ""
          this.secQuestionName = ""
        }
      }
    );

  }
  // Get security Question  
  getForgotSecurityQues() {
    this.userService.getForgotSecurityQuesAnsLinkByUser(window.localStorage['randId']).subscribe(
      data => {
        this.getForgotSecurity = data;
        //console.log("getForgotSecurity", data)
      }
    )
  }

  openCSRModal(showCSR: TemplateRef<any>) {
    this.csrModal = this.modalService.show(showCSR, {
      class: 'modal-sm',
      keyboard: false,
      backdrop: 'static'


    });
  }


  forgetSQues() {
    this.router.navigate([`/login`]);
  }
}
